// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-certificados-ssl-js": () => import("./../../../src/pages/certificados-ssl.js" /* webpackChunkName: "component---src-pages-certificados-ssl-js" */),
  "component---src-pages-dominios-js": () => import("./../../../src/pages/dominios.js" /* webpackChunkName: "component---src-pages-dominios-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-hosting-jsx": () => import("./../../../src/templates/hosting.jsx" /* webpackChunkName: "component---src-templates-hosting-jsx" */)
}

